var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;opacity:0;}.b{fill:#0f1010;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.785,15.671H30.311A1.285,1.285,0,0,0,31.6,14.385h0A1.285,1.285,0,0,0,30.311,13.1H14.785A1.285,1.285,0,0,0,13.5,14.385h0A1.285,1.285,0,0,0,14.785,15.671Z",
    transform: "translate(-7.596 -13.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.744,48.671H36.256A1.265,1.265,0,0,0,37.5,47.385h0A1.265,1.265,0,0,0,36.256,46.1H14.744A1.265,1.265,0,0,0,13.5,47.385h0A1.265,1.265,0,0,0,14.744,48.671Z",
    transform: "translate(-13.5 -35.385)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.785,81.671H30.311A1.285,1.285,0,0,0,31.6,80.385h0A1.285,1.285,0,0,0,30.311,79.1H14.785A1.285,1.285,0,0,0,13.5,80.385h0A1.285,1.285,0,0,0,14.785,81.671Z",
    transform: "translate(-7.596 -57.671)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.0986aaf15d53559e2bdf701fd31c0a9a.svg";
export { ForwardRef as ReactComponent };